import React from 'react'
import { inject } from 'mobx-react'
import { UPGRADE_LINK_CLICK_FAILED, UPGRADE_LINK_CLICK_SUCCESS } from 'core/constants'
import CONFIG from 'core/globals'
import { getUpgradeSourceTypeFromUrl } from 'core/helpers'
import { isNuxtUpgradeHookLink } from 'core/upgradeLink'

const UpgradeLink = ({ actions, store, href = '#', children, className = '' }) => {
  const redirect = e => {
    e.preventDefault()
    let url = e.currentTarget.getAttribute('href')
    if (url === '#') {
      url = CONFIG.urls.upgrade(store.conversation.otherUserProfile)
    }

    actions.ccp.monitoring({ stat: UPGRADE_LINK_CLICK_SUCCESS }).then(() => {
      if (isNuxtUpgradeHookLink(url, CONFIG)) {
        const upgradeType = getUpgradeSourceTypeFromUrl(url)
        const { onBlockedMessage } = CONFIG.hooks
        onBlockedMessage(upgradeType)
        return
      }
      if (url === 'OPEN_UPGRADE_POPUP') {
        CONFIG.hooks?.onOpenUpgradePopup?.()
        return
      }
      window.location.href = url
    }).catch(() => {
      //try to do a redirect if the monitoring request fails
      window.location.href = url
    })

    setTimeout(function() {
      //redirect failed after 5 seconds, send monitoring request
      actions.ccp.monitoring({ stat: UPGRADE_LINK_CLICK_FAILED })
    }, 5000)
  }

  return (
    <a
      href={href}
      className={`${className} upgrade-link no-under`}
      onClick={redirect}>
      {children}
    </a>
  )
}

export default inject('actions', 'store')(UpgradeLink)
